import { EntityReferences } from "../models/mappers";
import { EntityName } from "./entityNames";
import { AnyEntityField } from "./metadata";

export const contractRegionFields = [
  "gaming_contractregionid",
  "gaming_ContractSubTypeId",
  "gaming_ContractTypeId",
  "gaming_name",
  "gaming_PlatformId",
  "ggp_contracttype",
  "ggp_region",
  "ggp_secondarycontracttype",
  "ggp_subcontract",
] as const;

export const contractRegionReferences: EntityReferences<EntityName.gaming_contractregion> = {
  [EntityName.gaming_contracttype]: ["gaming_ContractTypeId"],
  [EntityName.gaming_contractsubtype]: ["gaming_ContractSubTypeId"],
};

export const contractRegionKey: AnyEntityField<EntityName.gaming_contractregion> =
  "gaming_contractregionid";
